/* 🤖 this file was generated by svg-to-ts */
export const matIconSignalWifiStatusbarNull: {
  name: 'signal-wifi-statusbar-null';
  data: string;
} = {
  name: 'signal-wifi-statusbar-null',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 4C7.31 4 3.07 5.9 0 8.98L12 21 24 8.98A16.88 16.88 0 0 0 12 4zM2.92 9.07C5.51 7.08 8.67 6 12 6s6.49 1.08 9.08 3.07L12 18.17l-9.08-9.1z"/></svg>`
};
